module.exports = __webpack_public_path__ + "img/Security.16b44f4e.svg";